export const GTM_CODE_DEV = 'GTM-M973827';
export const GTM_CODE_PROD = 'GTM-T47852Z';

export const PAGEVIEW = {
  environment: {
    path: 'site.environment',
    value: null,
  },
  useragent: {
    path: 'site.useragent',
    value: null,
  },
  permissions: {
    path: 'site.permissions',
    value: null,
  },
  accessibility: {
    path: 'site.accessibility',
    value: null,
  },
  geolocation: {
    path: 'visitor.geolocation',
    value: null,
  },
  loginType: {
    path: 'visitor.login.type',
    value: null,
  },
  loginauthenticationtype: {
    path: 'visitor.login.authenticationtype',
    value: null,
  },
  clientIdpf: {
    path: 'visitor.client.idpf',
    value: null,
  },
  clientAccounttype: {
    path: 'visitor.client.accounttype',
    value: null,
  },
  clientAgency: {
    path: 'visitor.client.agency',
    value: null,
  },
  clientCommercialsegment: {
    path: 'visitor.client.commercialsegment',
    value: null,
  },
  clientDeclaredincomerange: {
    path: 'visitor.client.declaredincomerange',
    value: null,
  },
  clientLimitusage: {
    path: 'visitor.client.limitusage',
    value: null,
  },
  clientLoannearduedate: {
    path: 'visitor.client.loannearduedate',
    value: null,
  },
  clientOccupation: {
    path: 'visitor.client.occupation',
    value: null,
  },
  clientProfile: {
    path: 'visitor.client.profile',
    value: null,
  },
  clientRewardsprogram: {
    path: 'visitor.client.rewardsprogram',
    value: null,
  },
  clientScore: {
    path: 'visitor.client.score',
    value: null,
  },
  clientStars: {
    path: 'visitor.client.stars',
    value: null,
  },
  clientTitularitycode: {
    path: 'visitor.client.titularitycode',
    value: null,
  },
  clientType: {
    path: 'visitor.client.type',
    value: null,
  },
  clienClientrewardsvaluerange: {
    path: 'visitor.client.clientrewardsvaluerange',
    value: null,
  },
  clientContracteddigitalproducts: {
    path: 'visitor.client.contracteddigitalproducts',
    value: null,
  },
  // Pantallas de AreaComunRegistroHabilitar - Registro
  // Pantalla home
  pv134pageName: {
    path: 'page.name',
    value: 'HomePublica',
  },
  pv134siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv134pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv134internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv134errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantalla 1
  pv136pageName: {
    path: 'page.name',
    value: 'RecomendacionesRegistro',
  },
  pv136siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv136pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv136internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv136errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv136transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },

  // Pantalla 2
  pv1pageName: {
    path: 'page.name',
    value: 'CapturaDatosRegistro',
  },
  pv1siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv1pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv1customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv1internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv1errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv1transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },
  pv1transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },

  // Pantalla 3
  pv2pageName: {
    path: 'page.name',
    value: 'SeleccionarUsuarioContrasena',
  },
  pv2siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv2pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv2customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv2internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv2errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv2transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },
  pv2transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv2transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv2productCategory: {
    path: 'transaction.details.productcategory',
    value: null,
  },

  // Pantalla 4
  pv3pageName: {
    path: 'page.name',
    value: 'SeleccionarImagenFrase',
  },
  pv3siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv3pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv3customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv3internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv3errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv3transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },
  pv3transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },

  // Pantalla 9
  pv137pageName: {
    path: 'page.name',
    value: 'RecomendacionesPreguntas',
  },
  pv137siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv137pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv137customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv137internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv137errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv137transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },
  pv137transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },

  // Pantalla 5
  pv4pageName: {
    path: 'page.name',
    value: 'SeleccionarPreguntas',
  },
  pv4siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv4pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv4customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv4internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv4errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv4transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },
  pv4transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },

  // Pantalla 6
  pv5pageName: {
    path: 'page.name',
    value: 'RegistroExitosoSinOTP',
  },
  pv5siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv5pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv5customTransactionStep: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv5internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv5errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv5transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },
  pv5transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },

  // Pantalla 7
  pv6pageName: {
    path: 'page.name',
    value: 'SolicitarCodigoOTP',
  },
  pv6siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv6pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv6customTransactionStep: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv6internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv6errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv6transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },
  pv6transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },

  // Pantalla 8
  pv7pageName: {
    path: 'page.name',
    value: 'RegistroExitosoConOTP',
  },
  pv7siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv7pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv7customevents: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv7internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv7errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv7transactionName: {
    path: 'transaction.name',
    value: 'Registro',
  },
  pv7transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },

  // Pantallas del documento AreaComunRegistroLoguear  - JornadaAcceso
  // Pantalla 1
  pv8pageName: {
    path: 'page.name',
    value: 'HomePublica',
  },
  pv8siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv8pageAction: {
    path: 'page.action',
    value: 'Loguear',
  },
  pv8pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv8internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv8errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Eventos de documento AreaComunHomeConsultar  -  Home

  // Pantalla 1
  pv10pageName: {
    path: 'page.name',
    value: 'HomeTransaccional',
  },
  pv10siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv10pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv10subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv10pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv10pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv10internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv10errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantalla de documento CampanasOfertaProductosOfertar  -  AprobadosEnFirme

  // Pantalla 1
  pv11pageName: {
    path: 'page.name',
    value: 'QueTeGustaMas',
  },
  pv11siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv11pageFamily: {
    path: 'page.family',
    value: 'Campanas',
  },
  pv11subFamily: {
    path: 'page.subfamily',
    value: 'OfertaProductos',
  },
  pv11pageAction: {
    path: 'page.action',
    value: 'Ofertar',
  },
  pv11pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv11customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv11internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv11errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv11transactionName: {
    path: 'transaction.name',
    value: 'AprobadosEnFirme',
  },
  pv11transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },

  // Pantalla 2

  pv12pageName: {
    path: 'page.name',
    value: 'ConfirmarDatos',
  },
  pv12siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv12pageFamily: {
    path: 'page.family',
    value: 'Campanas',
  },
  pv12subFamily: {
    path: 'page.subfamily',
    value: 'OfertaProductos',
  },
  pv12pageAction: {
    path: 'page.action',
    value: 'Ofertar',
  },
  pv12pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv12customTransactionStep: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv12internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv12errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv12transactionName: {
    path: 'transaction.name',
    value: 'AprobadosEnFirme',
  },
  pv12transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },

  // Pantallas documento Inversiones Ahorro Programado Contratar - Ahorro programado
  // Pantalla 1

  pv13pageName: {
    path: 'page.name',
    value: 'SimulayContrataAHP',
  },
  pv13siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv13pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv13subFamily: {
    path: 'page.subfamily',
    value: 'AhorroProgramado',
  },
  pv13pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv13pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv13customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },

  pv13internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv13errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv13transactionName: {
    path: 'transaction.name',
    value: 'AhorroProgramado',
  },
  pv13transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },

  // Pantalla 2
  pv14pageName: {
    path: 'page.name',
    value: 'Aceptacion',
  },

  pv14siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv14pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv14subFamily: {
    path: 'page.subfamily',
    value: 'AhorroProgramado',
  },
  pv14pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv14pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv14customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv14customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv14internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv14errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv14transactionName: {
    path: 'transaction.name',
    value: 'AhorroProgramado',
  },
  pv14transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv14transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv14transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantalla 3
  pv15pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv15siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv15pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv15subFamily: {
    path: 'page.subfamily',
    value: 'AhorroProgramado',
  },
  pv15pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv15pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv15customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv15customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv15internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv15errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv15transactionName: {
    path: 'transaction.name',
    value: 'AhorroProgramado',
  },
  pv15transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv15transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv15transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantallas documento Inversiones Depositos Plazo Fijo Contratar - Itau Rentable
  // Pantalla 1

  pv16pageName: {
    path: 'page.name',
    value: 'SimulacionYContratacion',
  },
  pv16siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv16pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv16subFamily: {
    path: 'page.subfamily',
    value: 'DepositosPlazoFijo',
  },
  pv16pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv16pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv16customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv16internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv16errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv16transactionName: {
    path: 'transaction.name',
    value: 'ItauRentable',
  },
  pv16transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },

  // Pantalla 2

  pv17pageName: {
    path: 'page.name',
    value: 'Aceptacion',
  },
  pv17siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv17pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv17subFamily: {
    path: 'page.subfamily',
    value: 'DepositosPlazoFijo',
  },
  pv17pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv17pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv17customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv17customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv17internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv17errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv17transactionName: {
    path: 'transaction.name',
    value: 'ItauRentable',
  },
  pv17transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv17transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantalla 3

  pv18pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },
  pv18siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv18pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv18subFamily: {
    path: 'page.subfamily',
    value: 'DepositosPlazoFijo',
  },
  pv18pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv18pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv18customTransactioncomplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv18customTransactionvalue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv18internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv18errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv18transactionName: {
    path: 'transaction.name',
    value: 'ItauRentable',
  },
  pv18transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv18transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv18transactionInstallmentsterm: {
    path: 'transaction.details.installmentsterm',
    value: null,
  },
  pv18transactionTax: {
    path: 'transaction.details.tax',
    value: null,
  },
  pv18transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },

  // Pantalla de documento Inversiones Home Agregar - CDT Virtual
  // Pantalla 1

  pv19pageName: {
    path: 'page.name',
    value: 'AhorroeInversion',
  },
  pv19siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv19pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv19subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv19pageAction: {
    path: 'page.action',
    value: 'Agregar',
  },
  pv19pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv19internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv19errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantalla 2

  pv20pageName: {
    path: 'page.name',
    value: 'SeleccionCDTVirtual',
  },
  pv20siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv20pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv20subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv20pageAction: {
    path: 'page.action',
    value: 'Agregar',
  },
  pv20pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv20customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv20internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv20errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv20transactionName: {
    path: 'transaction.name',
    value: 'CDTVirtual',
  },
  pv20transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },

  // Pantalla 3

  pv21pageName: {
    path: 'page.name',
    value: 'FormaDePago',
  },
  pv21siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv21pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv21subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv21pageAction: {
    path: 'page.action',
    value: 'Agregar',
  },
  pv21pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv21customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv21customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv21internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv21errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv21transactionName: {
    path: 'transaction.name',
    value: 'CDTVirtual',
  },
  pv21transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv21transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv21transactionTax: {
    path: 'transaction.details.tax',
    value: null,
  },
  pv21transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv21transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantalla 4

  pv22pageName: {
    path: 'page.name',
    value: 'RealizaTuInversion',
  },
  pv22siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv22pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv22subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv22pageAction: {
    path: 'page.action',
    value: 'Agregar',
  },
  pv22pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv22customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv22customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv22internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv22errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv22transactionName: {
    path: 'transaction.name',
    value: 'CDTVirtual',
  },
  pv22transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv22transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv22transactionTax: {
    path: 'transaction.details.tax',
    value: null,
  },
  pv22transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv22transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantalla 5

  pv23pageName: {
    path: 'page.name',
    value: 'ConfirmacionCDTVirtual',
  },
  pv23siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv23pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv23subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv23pageAction: {
    path: 'page.action',
    value: 'Agregar',
  },
  pv23pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv23customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv23customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv23internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv23errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv23transactionName: {
    path: 'transaction.name',
    value: 'CDTVirtual',
  },
  pv23transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv23transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv23transactionTax: {
    path: 'transaction.details.tax',
    value: null,
  },
  pv23transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv23transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantallas documento Transferencias Giros IEDE Transferir - Giros internacionales Enviar
  // Pantalla 1

  pv24pageName: {
    path: 'page.name',
    value: 'EnvioGiroInternacional',
  },
  pv24siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv24pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv24subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv24pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv24pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv24customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv24internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv24errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv24transactionName: {
    path: 'transaction.name',
    value: 'EnvioGiros',
  },
  pv24transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },

  // Pantalla 2

  pv25pageName: {
    path: 'page.name',
    value: 'VerificacionDatosGiroInternacional',
  },
  pv25siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv25pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv25subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv25pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv25pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv25customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv25customTransactionSimulationValue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv25internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv25errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv25transactionName: {
    path: 'transaction.name',
    value: 'EnvioGiros',
  },
  pv25transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv25transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantalla 3

  pv26pageName: {
    path: 'page.name',
    value: 'ConfirmacionGiroInternacional',
  },
  pv26siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv26pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv26subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv26pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv26pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv26customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv26customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv26internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv26errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv26transactionName: {
    path: 'transaction.name',
    value: 'EnvioGiros',
  },
  pv26transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv26transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv26transactionOriginaccounttype: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv26transactionDestinationbank: {
    path: 'transaction.details.destinationbank',
    value: null,
  },

  // Pantallas de documento Tarjetas Alimentacion Solicitar - Avance
  // Pantalla 1

  pv27pageName: {
    path: 'page.name',
    value: 'EscogeTuTarjeta',
  },
  pv27siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv27pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv27subFamily: {
    path: 'page.subfamily',
    value: 'Alimentacion',
  },
  pv27pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv27pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv27customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv27internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv27errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv27transactionName: {
    path: 'transaction.name',
    value: 'Avances',
  },
  pv27transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },

  // Pantalla 2

  pv28pageName: {
    path: 'page.name',
    value: 'RealizaTuAvance',
  },
  pv28siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv28pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv28subFamily: {
    path: 'page.subfamily',
    value: 'Alimentacion',
  },
  pv28pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv28pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv28customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv28customTransactionSimulationValue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv28internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv28errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv28transactionName: {
    path: 'transaction.name',
    value: 'Avances',
  },
  pv28transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv28transactionCardcategory: {
    path: 'transaction.details.cardcategory',
    value: null,
  },
  pv28transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv28transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv28transactionInstallmentsterm: {
    path: 'transaction.details.installmentsterm',
    value: null,
  },
  pv28transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantalla 3

  pv29pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },
  pv29siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv29pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv29subFamily: {
    path: 'page.subfamily',
    value: 'Alimentacion',
  },
  pv29pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv29pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv29customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv29customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv29internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv29errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv29transactionName: {
    path: 'transaction.name',
    value: 'Avances',
  },
  pv29transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv29transactionCardcategory: {
    path: 'transaction.details.cardcategory',
    value: null,
  },
  pv29transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv29transactionOriginaccounttype: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv29transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv29transactionInstallmentsterm: {
    path: 'transaction.details.installmentsterm',
    value: null,
  },
  pv29transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },

  // Pantallas de documento Area Comun Registro Habilitar- Desbloqueo clave
  // Pantalla 1

  pv30siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv30pageName: {
    path: 'page.name',
    value: 'HomePublicoPortal',
  },
  pv30pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv30internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv30errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantalla 2

  pv31siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv31pageName: {
    path: 'page.name',
    value: 'CapturaDatosDesbloqueo',
  },
  pv31pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv31customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv31internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv31errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv31transactionName: {
    path: 'transaction.name',
    value: 'Desbloqueo',
  },
  pv31transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },

  // Pantalla 3
  pv32siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv32pageName: {
    path: 'page.name',
    value: 'SeleccionarImagenFrase',
  },
  pv32pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv32customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv32internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv32errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv32transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoClave',
  },
  pv32transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv32transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv32productCategory: {
    path: 'transaction.details.productcategory',
    value: null,
  },

  // Pantalla 4
  pv33siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv33pageName: {
    path: 'page.name',
    value: 'ResponderPreguntasClave',
  },
  pv33pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv33customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv33internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv33errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv33transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoClave',
  },
  pv33transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },

  // Pantalla 5
  pv34siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv34pageName: {
    path: 'page.name',
    value: 'SolicitarCodigoOTPClave',
  },
  pv34pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv34customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv34internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv34errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv34transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoClave',
  },
  pv34transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },

  // Pantalla 6
  pv35siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv35pageName: {
    path: 'page.name',
    value: 'CrearNuevaClave',
  },
  pv35pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv35customTransactionStep: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv35internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv35errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv35transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoClave',
  },
  pv35transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },

  // Pantalla 7
  pv36siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv36pageName: {
    path: 'page.name',
    value: 'DesbloqueoClaveExitoso',
  },
  pv36pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv36customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv36internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv36errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv36transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoClave',
  },
  pv36transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },

  // Pantallas de ServiciosSolicitudConfigurar - Actualización de datos
  // Pantalla 1
  pv37pageName: {
    path: 'page.name',
    value: 'InicioNuevosDatos',
  },

  pv37siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv37pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv37subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv37pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv37pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv37internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv37errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv37transactionName: {
    path: 'transaction.name',
    value: 'ActualizacionDatos',
  },

  // Pantalla 2
  pv38pageName: {
    path: 'page.name',
    value: 'DiligenciarNuevosDatos',
  },

  pv38siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv38pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv38subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv38pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv38pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv38customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv38internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv38errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv38transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv38transactionName: {
    path: 'transaction.name',
    value: 'ActualizacionDatos',
  },

  // Pantalla 3
  pv39pageName: {
    path: 'page.name',
    value: 'ActualizacionDatos',
  },

  pv39siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv39pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv39subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv39pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv39pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv39customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv39internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv39errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv39transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv39transactionName: {
    path: 'transaction.name',
    value: 'ActualizacionDatos',
  },

  // Pantalla 4
  pv40pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv40siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv40pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv40subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv40pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv40pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv40customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv40internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv40errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv40transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv40transactionName: {
    path: 'transaction.name',
    value: 'ActualizacionDatos',
  },

  // Pantallas de PagamentosServiciosPagar - Pago tarjeta de crédito
  // Pantalla 1
  pv41pageName: {
    path: 'page.name',
    value: 'EscogerTarjeta',
  },

  pv41siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv41pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv41subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv41pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv41pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv41customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv41internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv41errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv41transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv41transactionName: {
    path: 'transaction.name',
    value: 'PagarTarjeta',
  },

  // Pantalla 2
  pv42pageName: {
    path: 'page.name',
    value: 'PagarTarjeta',
  },

  pv42siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv42pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv42subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv42pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv42pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv42customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv42internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv42errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv42transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv42transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv42transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv42transactionCardcategory: {
    path: 'transaction.details.cardcategory',
    value: null,
  },
  pv42transactionName: {
    path: 'transaction.name',
    value: 'PagarTarjeta',
  },
  pv42customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },

  // Pantalla 3
  pv43pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv43siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv43pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv43subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv43pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv43pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv43customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv43customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv43internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv43errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv43transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv43transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv43transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv43transactionCardcategory: {
    path: 'transaction.details.cardcategory',
    value: null,
  },
  pv43transactionName: {
    path: 'transaction.name',
    value: 'PagarTarjeta',
  },

  // Pantallas de PagamentosFacturaPagar - Pago Prestamo
  // Pantalla 1
  pv44pageName: {
    path: 'page.name',
    value: 'EscogerPrestamo',
  },

  pv44siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv44pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv44subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv44pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv44pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv44customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv44internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv44errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv44transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv44transactionName: {
    path: 'transaction.name',
    value: 'PagoPrestamo',
  },

  // Pantalla 2
  pv45pageName: {
    path: 'page.name',
    value: 'PagarPrestamo',
  },

  pv45siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv45pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv45subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv45pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv45pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv45customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv45customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv45internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv45errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv45transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv45transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv45transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv45transactionPaymentAmounttype: {
    path: 'transaction.details.paymentamounttype',
    value: null,
  },
  pv45transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv45transactionName: {
    path: 'transaction.name',
    value: 'PagoPrestamo',
  },
  pv45transactionPaymentMethod: {
    path: 'transaction.details.paymentmethod',
    value: null,
  },

  // Pantalla 3
  pv46pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv46siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv46pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv46subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv46pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv46pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv46customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv46customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv46internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv46errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv46transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv46transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv46transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv46transactionPaymentAmounttype: {
    path: 'transaction.details.paymentamounttype',
    value: null,
  },
  pv46transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv46transactionName: {
    path: 'transaction.name',
    value: 'PagoPrestamo',
  },
  pv46transactionPaymentMethod: {
    path: 'transaction.details.paymentmethod',
    value: null,
  },

  // Pantallas de PagamentosServiciosPagar - Credito Rotativo
  // Pantalla 1
  pv47pageName: {
    path: 'page.name',
    value: 'EscogerCreditoRotativo',
  },

  pv47siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv47pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv47subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv47pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv47pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv47customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv47internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv47errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv47transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv47transactionName: {
    path: 'transaction.name',
    value: 'CreditoRotativo',
  },

  // Pantalla 2
  pv48pageName: {
    path: 'page.name',
    value: 'PagarCreditoRotativo',
  },

  pv48siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv48pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv48subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv48pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv48pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv48customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv48customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv48internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv48errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv48transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv48transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv48transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv48transactionName: {
    path: 'transaction.name',
    value: 'CreditoRotativo',
  },

  // Pantalla 3
  pv49pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv49siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv49pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv49subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv49pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv49pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv49customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv49customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv49internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv49errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv49transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv49transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv49transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv49transactionName: {
    path: 'transaction.name',
    value: 'CreditoRotativo',
  },

  // Pantallas de TransferenciasCuentasVirtualesTransferir - Transferencia Otros bancos
  // Pantalla 1
  pv50pageName: {
    path: 'page.name',
    value: 'HomeTransferencias',
  },

  pv50siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv50pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv50subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv50pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv50pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv50internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv50errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv50transactionName: {
    path: 'transaction.name',
    value: 'TransferenciaOtrasCuentas',
  },

  // Pantalla 2
  pv51pageName: {
    path: 'page.name',
    value: 'EscogerCuentas',
  },

  pv51siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv51pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv51subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv51pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv51pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv51customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv51internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv51errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv51transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv51transactionBankTransferToSameHolder: {
    path: 'transaction.details.banktransfertosameholder',
    value: 'No',
  },
  pv51transactionName: {
    path: 'transaction.name',
    value: 'TransferenciaOtrasCuentas',
  },

  // Pantalla 3
  pv52pageName: {
    path: 'page.name',
    value: 'RealizarTransferencia',
  },

  pv52siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv52pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv52subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv52pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv52pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv52customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv52customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv52internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv52errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv52transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv52transactionOriginaccounttype: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv52transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv52transactionBankTransferToSameHolder: {
    path: 'transaction.details.banktransfertosameholder',
    value: 'No',
  },
  pv52transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv52transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv52transactionName: {
    path: 'transaction.name',
    value: 'TransferenciaOtrasCuentas',
  },

  // Pantalla 4
  pv53pageName: {
    path: 'page.name',
    value: 'ConfirmarTransferencia',
  },

  pv53siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv53pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv53subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv53pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv53pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv53customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv53customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv53internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv53errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv53transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv53transactionOriginaccounttype: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv53transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv53transactionBankTransferToSameHolder: {
    path: 'transaction.details.banktransfertosameholder',
    value: 'No',
  },
  pv53transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv53transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv53transactionName: {
    path: 'transaction.name',
    value: 'TransferenciaOtrasCuentas',
  },

  // Pantallas de TransferenciasCuentasPropiasTransferir - Transferencia cuetas Itau
  // Pantalla 1
  pv54pageName: {
    path: 'page.name',
    value: 'EscogerCuenta',
  },

  pv54siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv54pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv54subFamily: {
    path: 'page.subfamily',
    value: 'CuentasPropias',
  },
  pv54pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv54pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv54customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv54internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv54errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv54transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv54transactionBankTransferToSameHolder: {
    path: 'transaction.details.banktransfertosameholder',
    value: 'Si',
  },
  pv54transactionName: {
    path: 'transaction.name',
    value: 'TranferenciaEntreCuentasItau',
  },

  // Pantalla 2
  pv55pageName: {
    path: 'page.name',
    value: 'RealizarTransferencia',
  },

  pv55siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv55pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv55subFamily: {
    path: 'page.subfamily',
    value: 'CuentasPropias',
  },
  pv55pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv55pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv55customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv55customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv55internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv55errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv55transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv55transactionBankTransferToSameHolder: {
    path: 'transaction.details.banktransfertosameholder',
    value: 'Si',
  },
  pv55transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv55transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv55transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv55transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Transferencia',
  },
  pv55transactionName: {
    path: 'transaction.name',
    value: 'TranferenciaEntreCuentasItau',
  },

  // Pantalla 3
  pv56pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv56siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv56pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv56subFamily: {
    path: 'page.subfamily',
    value: 'CuentasPropias',
  },
  pv56pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv56pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv56customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv56customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv56internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv56errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv56transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv56transactionBankTransferToSameHolder: {
    path: 'transaction.details.banktransfertosameholder',
    value: 'Si',
  },
  pv56transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv56transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv56transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv56transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Transferencia',
  },
  pv56transactionName: {
    path: 'transaction.name',
    value: 'TranferenciaEntreCuentasItau',
  },

  // Pantallas de TarjetasCreditoBloquear - Bloqueo Tarjeta
  // Pantalla 1
  pv57pageName: {
    path: 'page.name',
    value: 'BloqueoTarjeta',
  },

  pv57siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv57pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv57subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv57pageAction: {
    path: 'page.action',
    value: 'Bloquear',
  },
  pv57pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv57customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv57internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv57errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv57transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv57transactionName: {
    path: 'transaction.name',
    value: 'BloquearTarjeta',
  },

  // Pantalla 2
  pv58pageName: {
    path: 'page.name',
    value: 'EscogerTarjeta',
  },

  pv58siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv58pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv58subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv58pageAction: {
    path: 'page.action',
    value: 'Bloquear',
  },
  pv58pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv58customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv58internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv58errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv58transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv58transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv58transactionCardcategory: {
    path: 'transaction.details.cardcategory',
    value: null,
  },
  pv58transactionName: {
    path: 'transaction.name',
    value: 'BloquearTarjeta',
  },

  // Pantalla 3
  pv59pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv59siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv59pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv59subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv59pageAction: {
    path: 'page.action',
    value: 'Bloquear',
  },
  pv59pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv59customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv59internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv59errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv59transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv59transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv59transactionCardcategory: {
    path: 'transaction.details.cardcategory',
    value: null,
  },
  pv59transactionName: {
    path: 'transaction.name',
    value: 'BloquearTarjeta',
  },

  // Pantallas de PagamentosFacturaPagar - Domiciliación Pagos
  // Pantalla 1
  pv60pageName: {
    path: 'page.name',
    value: 'EscogePagProgPagos',
  },

  pv60siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv60pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv60subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv60pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv60pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv60customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv60internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv60errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv60transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv60transactionName: {
    path: 'transaction.name',
    value: 'PagoFactura',
  },

  // Pantalla 2
  pv61pageName: {
    path: 'page.name',
    value: 'RealizaPagProgPagos',
  },

  pv61siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv61pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv61subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv61pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv61pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv61customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv61customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv61internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv61errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv61transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv61transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv61transactionTransactionInstitution: {
    path: 'transaction.details.transactioninstitution',
    value: null,
  },
  pv61transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv61transactionName: {
    path: 'transaction.name',
    value: 'PagoFactura',
  },

  // Pantalla 3
  pv62pageName: {
    path: 'page.name',
    value: 'ConfirmacionPagProgPagos',
  },

  pv62siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv62pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv62subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv62pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv62pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv62customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv62customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv62internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv62errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv62transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv62transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv62transactionTransactionInstitution: {
    path: 'transaction.details.transactioninstitution',
    value: null,
  },
  pv62transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv62transactionName: {
    path: 'transaction.name',
    value: 'PagoFactura',
  },

  // Pantallas de PagamentosFacturaPagar - Domiciliación Inscribir
  // Pantalla 1
  pv63pageName: {
    path: 'page.name',
    value: 'PagosFacturasConvenios',
  },

  pv63siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv63pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv63subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv63pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv63pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv63internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv63errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantalla 2
  pv64pageName: {
    path: 'page.name',
    value: 'EscogeFacProgPagos',
  },

  pv64siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv64pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv64subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv64pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv64pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv64customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv64internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv64errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv64transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv64transactionName: {
    path: 'transaction.name',
    value: 'InscripcionFactura',
  },

  // Pantalla 3
  pv65pageName: {
    path: 'page.name',
    value: 'InscribeFacProgPagos',
  },

  pv65siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv65pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv65subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv65pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv65pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv65customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv65internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv65errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv65transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv65transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv65transactionTransactionInstitution: {
    path: 'transaction.details.transactioninstitution',
    value: null,
  },
  pv65transactionName: {
    path: 'transaction.name',
    value: 'InscripcionFactura',
  },

  // Pantalla 4
  pv66pageName: {
    path: 'page.name',
    value: 'ConfirmacionFacProgPagos',
  },

  pv66siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv66pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv66subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv66pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv66pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv66customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv66internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv66errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv66transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv66transactionTransactionInstitution: {
    path: 'transaction.details.transactioninstitution',
    value: null,
  },
  pv66transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv66transactionName: {
    path: 'transaction.name',
    value: 'InscripcionFactura',
  },

  // Pantallas de PagamentosFacturaPagar - Domiciliación Programar
  // Pantalla 1
  pv67pageName: {
    path: 'page.name',
    value: 'EscogeProgPagos',
  },

  pv67siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv67pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv67subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv67pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv67pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv67customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv67internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv67errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv67transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv67transactionName: {
    path: 'transaction.name',
    value: 'ProgramacionPagos',
  },

  // Pantalla 2
  pv68pageName: {
    path: 'page.name',
    value: 'InscribeProgPagos',
  },

  pv68siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv68pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv68subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv68pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv68pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv68customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv68customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv68internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv68errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv68transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv68transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv68productCategory: {
    path: 'transaction.details.productcategory',
    value: null,
  },
  pv68transactionTransactionInstitution: {
    path: 'transaction.details.transactioninstitution',
    value: null,
  },
  pv68transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv68transactionName: {
    path: 'transaction.name',
    value: 'ProgramacionPagos',
  },

  // Pantalla 3
  pv69pageName: {
    path: 'page.name',
    value: 'confirmacionProgPagos',
  },

  pv69siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv69pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv69subFamily: {
    path: 'page.subfamily',
    value: 'Factura',
  },
  pv69pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv69pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv69customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv69customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv69internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv69errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv69transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv69transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv69productCategory: {
    path: 'transaction.details.productcategory',
    value: null,
  },
  pv69transactionTransactionInstitution: {
    path: 'transaction.details.transactioninstitution',
    value: null,
  },
  pv69transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv69transactionName: {
    path: 'transaction.name',
    value: 'ProgramacionPagos',
  },

  // Pantallas de PagamentosServiciosPagar - Pagos TC otros bancos
  // Pantalla 1
  pv70pageName: {
    path: 'page.name',
    value: 'EscogerTarjeta',
  },

  pv70siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv70pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv70subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv70pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv70pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv70customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv70internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv70errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv70transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv70transactionName: {
    path: 'transaction.name',
    value: 'PagosPagarTarjeta',
  },

  // Pantalla 2
  pv71pageName: {
    path: 'page.name',
    value: 'PagarTarjeta',
  },

  pv71siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv71pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv71subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv71pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv71pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv71customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv71customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv71internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv71errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv71transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv71transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv71transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv71transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv71transactionName: {
    path: 'transaction.name',
    value: 'PagosPagarTarjeta',
  },
  pv71transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },

  // Pantalla 3
  pv72pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv72siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv72pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv72subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv72pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv72pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv72customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv72internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv72errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv72transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv72transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv72transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv72transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv72transactionName: {
    path: 'transaction.name',
    value: 'PagosPagarTarjeta',
  },
  pv72transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },

  // Pantallas de AtendimentoFormularioSolicitar - Orden de no pago
  // Pantalla 1
  pv73pageName: {
    path: 'page.name',
    value: 'DiligenciarDatos',
  },

  pv73siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv73pageFamily: {
    path: 'page.family',
    value: 'Atendimento',
  },
  pv73subFamily: {
    path: 'page.subfamily',
    value: 'Formulario',
  },
  pv73pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv73pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv73customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv73internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv73errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv73transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv73transactionName: {
    path: 'transaction.name',
    value: 'SeguridadOrdenNoPago',
  },

  // Pantalla 2
  pv74pageName: {
    path: 'page.name',
    value: 'RegistraOrden',
  },

  pv74siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv74pageFamily: {
    path: 'page.family',
    value: 'Atendimento',
  },
  pv74subFamily: {
    path: 'page.subfamily',
    value: 'Formulario',
  },
  pv74pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv74pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv74customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv74internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv74errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv74transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv74transactionName: {
    path: 'transaction.name',
    value: 'SeguridadOrdenNoPago',
  },

  // Pantalla 3
  pv75pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv75siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv75pageFamily: {
    path: 'page.family',
    value: 'Atendimento',
  },
  pv75subFamily: {
    path: 'page.subfamily',
    value: 'Formulario',
  },
  pv75pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv75pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv75customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv75internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv75errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv75transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv75transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv75transactionName: {
    path: 'transaction.name',
    value: 'SeguridadOrdenNoPago',
  },

  // Pantallas de AreaComunRegistroHabilitar - Desbloqueo Pregunta
  // Pantalla 1
  pv76pageName: {
    path: 'page.name',
    value: 'ConfirmarImagenFraseUsuario',
  },

  pv76siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv76pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv76subFamily: {
    path: 'page.subfamily',
    value: 'Registro',
  },
  pv76pageAction: {
    path: 'page.action',
    value: 'Habilitar',
  },
  pv76pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv76customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv76internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv76errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv76transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv76transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoPreguntas',
  },

  // Pantalla 2
  pv77pageName: {
    path: 'page.name',
    value: 'IngresarUsuarioClave',
  },

  pv77siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv77pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv77subFamily: {
    path: 'page.subfamily',
    value: 'Registro',
  },
  pv77pageAction: {
    path: 'page.action',
    value: 'Habilitar',
  },
  pv77pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv77customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv77internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv77errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv77transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv77transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoPreguntas',
  },

  // Pantalla 3
  pv78pageName: {
    path: 'page.name',
    value: 'SolicitarCodigoOTPPreguntas',
  },

  pv78siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv78pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv78subFamily: {
    path: 'page.subfamily',
    value: 'Registro',
  },
  pv78pageAction: {
    path: 'page.action',
    value: 'Habilitar',
  },
  pv78pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv78customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv78internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv78errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv78transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv78transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoPreguntas',
  },

  // Pantalla 4
  pv79pageName: {
    path: 'page.name',
    value: 'SeleccionarNuevasPreguntas',
  },

  pv79siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv79pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv79subFamily: {
    path: 'page.subfamily',
    value: 'Registro',
  },
  pv79pageAction: {
    path: 'page.action',
    value: 'Habilitar',
  },
  pv79pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv79customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv79internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv79errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv79transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv79transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoPreguntas',
  },

  // Pantalla 5
  pv80pageName: {
    path: 'page.name',
    value: 'DesbloqueoPreguntasExitoso',
  },

  pv80siteChannel: {
    path: 'site.channel',
    value: 'SitioPublicoUN',
  },
  pv80pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv80subFamily: {
    path: 'page.subfamily',
    value: 'Registro',
  },
  pv80pageAction: {
    path: 'page.action',
    value: 'Habilitar',
  },
  pv80pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv80customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv80internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv80errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv80transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv80transactionName: {
    path: 'transaction.name',
    value: 'DesbloqueoPreguntas',
  },

  // Pantallas de ServiciosCertificacionConsultar - Extractos y certificados
  // Pantalla 1

  pv81pageName: {
    path: 'page.name',
    value: 'ExtractosCertificaciones',
  },
  pv81siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv81pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv81subFamily: {
    path: 'page.subfamily',
    value: 'Certificacion',
  },
  pv81pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv81pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv81internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv81errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantallas de PagamentosServiciosPagar - Inscribir TC otros bancos
  // Pantalla 1
  pv82pageName: {
    path: 'page.name',
    value: 'TarjetasOtroBancos',
  },

  pv82siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv82pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv82subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv82pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv82pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv82internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv82errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantalla 2
  pv83pageName: {
    path: 'page.name',
    value: 'DatosTarjeta',
  },

  pv83siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv83pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv83subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv83pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv83pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv83customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv83internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv83errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv83transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv83transactionName: {
    path: 'transaction.name',
    value: 'PagosInscribirTarjetas',
  },

  // Pantalla 3
  pv84pageName: {
    path: 'page.name',
    value: 'InscripcionTarjeta',
  },

  pv84siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv84pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv84subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv84pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv84pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv84customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv84customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv84internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv84errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv84transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv84transactionDestinationbank: {
    path: 'transaction.details.destinationbank',
    value: null,
  },
  pv84transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv84transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv84transactionName: {
    path: 'transaction.name',
    value: 'PagosInscribirTarjetas',
  },

  // Pantalla 4
  pv85pageName: {
    path: 'page.name',
    value: 'ConfirmacionInscripcionTC',
  },

  pv85siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv85pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv85subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv85pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv85pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv85customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv85customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv85internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv85errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv85transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv85transactionDestinationbank: {
    path: 'transaction.details.destinationbank',
    value: null,
  },
  pv85transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv85transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv85transactionName: {
    path: 'transaction.name',
    value: 'PagosInscribirTarjetas',
  },

  // Pantalla 5
  pv87pageName: {
    path: 'page.name',
    value: 'EscogerTarjeta',
  },

  pv87siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv87pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv87subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv87pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv87pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv87customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv87internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv87errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv87transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv87transactionName: {
    path: 'transaction.name',
    value: 'PagosTarjetaOtrosBancos',
  },

  // Pantalla 6
  pv88pageName: {
    path: 'page.name',
    value: 'PagoDeTarjeta',
  },

  pv88siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv88pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv88subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv88pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv88pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv88customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv88customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv88internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv88errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv88transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv88transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv88transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv88transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv88transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv88transactionName: {
    path: 'transaction.name',
    value: 'PagosTarjetaOtrosBancos',
  },

  // Pantalla 7
  pv89pageName: {
    path: 'page.name',
    value: 'ConfirmacionPagoTC',
  },

  pv89siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv89pageFamily: {
    path: 'page.family',
    value: 'Pagamentos',
  },
  pv89subFamily: {
    path: 'page.subfamily',
    value: 'Servicios',
  },
  pv89pageAction: {
    path: 'page.action',
    value: 'Pagar',
  },
  pv89pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv89customTransactioncomplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv89customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv89internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv89errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv89transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv89transactionCardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv89transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv89transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv89transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv89transactionName: {
    path: 'transaction.name',
    value: 'PagosTarjetaOtrosBancos',
  },

  // Pantallas de ServicioSolicitudConfigurar - Solicitud
  // Pantalla 1
  pv86siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv86pageName: {
    path: 'page.name',
    value: 'Solicitudes',
  },
  pv86pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv86subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv86pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv86pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv86internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv86errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantallas de TransferenciasCuentasVirtualesTransferir - TransfiYa

  // Pantalla 1
  pv90pageName: {
    path: 'page.name',
    value: 'TransferenciasYaHome',
  },

  pv90siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv90pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv90subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv90pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv90pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv90internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv90errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv90transactionName: {
    path: 'transaction.name',
    value: 'TransfiYa',
  },

  // Pantalla 2
  pv91pageName: {
    path: 'page.name',
    value: 'IngresoDatos',
  },

  pv91siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv91pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv91subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv91pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv91pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv91customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv91internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv91errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv91productCategory: {
    path: 'transaction.details.productcategory',
    value: 'Transferir',
  },
  pv91transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv91transactionName: {
    path: 'transaction.name',
    value: 'TransfiYa',
  },

  // Pantalla 3
  pv92pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },

  pv92siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv92pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv92subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv92pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv92pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv92customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv92customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv92internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv92errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv92productCategory: {
    path: 'transaction.details.productcategory',
    value: 'Transferir',
  },
  pv92transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv92transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv92transactionName: {
    path: 'transaction.name',
    value: 'TransfiYa',
  },

  // Pantalla 4
  pv93pageName: {
    path: 'page.name',
    value: 'Comprobante',
  },

  pv93siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv93pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv93subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv93pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv93pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv93customTransactioncomplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv93customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv93internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv93errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv93productCategory: {
    path: 'transaction.details.productcategory',
    value: 'Transferir',
  },
  pv93transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv93transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv93transactionName: {
    path: 'transaction.name',
    value: 'TransfiYa',
  },

  // Pantalla 5
  pv94pageName: {
    path: 'page.name',
    value: 'RecibirTransferencia',
  },

  pv94siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv94pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv94subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv94pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv94pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv94internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv94errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv94productCategory: {
    path: 'transaction.details.productcategory',
    value: 'RecibirTransferencia',
  },
  pv94transactionName: {
    path: 'transaction.name',
    value: 'TransfiYa',
  },

  // Pantalla 6
  pv95pageName: {
    path: 'page.name',
    value: 'ConfirmarRecepcion',
  },

  pv95siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv95pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv95subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv95pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv95pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv95customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv95internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv95errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv95productCategory: {
    path: 'transaction.details.productcategory',
    value: 'RecibirTransferencia',
  },
  pv95transactionName: {
    path: 'transaction.name',
    value: 'TransfiYa',
  },

  // Pantalla 7
  pv96pageName: {
    path: 'page.name',
    value: 'ErrorRecibir',
  },

  pv96siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv96pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv96subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv96pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv96pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv96internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv96errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv96productCategory: {
    path: 'transaction.details.productcategory',
    value: 'TransfiYa',
  },
  pv96transactionName: {
    path: 'transaction.name',
    value: 'Transferir',
  },

  // Pantalla 8
  pv121pageName: {
    path: 'page.name',
    value: 'ErrorEnviar',
  },
  pv121siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv121pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv121subFamily: {
    path: 'page.subfamily',
    value: 'CuentasVirtuales',
  },
  pv121pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv121pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv121internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv121errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv121productCategory: {
    path: 'transaction.details.productcategory',
    value: 'TransfiYa',
  },
  pv121transactionName: {
    path: 'transaction.name',
    value: 'Transferir',
  },

  // Pantallas TransferenciasGirosIEDETransferir - Giros Internacionales Recepción
  // Pantalla 1

  pv97pageName: {
    path: 'page.name',
    value: 'EscogerCuentaDestino',
  },
  pv97siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv97pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv97subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv97pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv97pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv97customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv97internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv97errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv97transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv97transactionName: {
    path: 'transaction.name',
    value: 'RecepcionGiros',
  },

  // Pantalla 2

  pv98pageName: {
    path: 'page.name',
    value: 'RecibirGiro',
  },
  pv98siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv98pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv98subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv98pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv98pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv98customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv98customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv98internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv98errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv98transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv98transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv98transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv98transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv98transactionName: {
    path: 'transaction.name',
    value: 'RecepcionGiros',
  },

  // Pantalla 3

  pv99pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },
  pv99siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv99pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv99subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv99pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv99pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv99customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv99customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv99internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv99errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv99transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv99transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv99transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv99transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv99transactionName: {
    path: 'transaction.name',
    value: 'RecepcionGiros',
  },

  // Pantallas TransferenciasGirosIEDETransferir - Giros Internacionales Inscripción
  // Pantalla 1

  pv100pageName: {
    path: 'page.name',
    value: 'IngresoDatos',
  },
  pv100siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv100pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv100subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv100pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv100pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv100customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv100internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv100errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv100transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv100transactionName: {
    path: 'transaction.name',
    value: 'InscripcionGiros',
  },

  // Pantalla 2

  pv101pageName: {
    path: 'page.name',
    value: 'ResumenInscripcion',
  },
  pv101siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv101pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv101subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv101pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv101pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv101customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv101internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv101errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv101transactionDestinationbank: {
    path: 'transaction.details.destinationbank',
    value: null,
  },
  pv101travelNoticeDestinationCountry: {
    path: 'transaction.details.travelnoticedestinationcountry',
    value: null,
  },
  pv101transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv101transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv101transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv101transactionName: {
    path: 'transaction.name',
    value: 'InscripcionGiros',
  },

  // Pantalla 3

  pv102pageName: {
    path: 'page.name',
    value: 'ConfirmacionInscripcion',
  },
  pv102siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv102pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv102subFamily: {
    path: 'page.subfamily',
    value: 'GirosIEDE',
  },
  pv102pageAction: {
    path: 'page.action',
    value: 'Transferir',
  },
  pv102pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv102customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv102internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv102errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv102transactionDestinationbank: {
    path: 'transaction.details.destinationbank',
    value: null,
  },
  pv102travelNoticeDestinationCountry: {
    path: 'transaction.details.travelnoticedestinationcountry',
    value: null,
  },
  pv102transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv102transactionCurrency: {
    path: 'transaction.details.currency',
    value: null,
  },
  pv102transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv102transactionName: {
    path: 'transaction.name',
    value: 'InscripcionGiros',
  },

  // Pantallas ServiciosSolicitudConfigurar - SeguridadAlertas
  // Pantalla 1

  pv103pageName: {
    path: 'page.name',
    value: 'Alertas',
  },
  pv103siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv103pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv103subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv103pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv103pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv103internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv103errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv103transactionName: {
    path: 'transaction.name',
    value: 'Alertas',
  },

  // Pantalla 2

  pv104pageName: {
    path: 'page.name',
    value: 'EscogerProducto',
  },
  pv104siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv104pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv104subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv104pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv104pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv104customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv104internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv104errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv104transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv104transactionName: {
    path: 'transaction.name',
    value: 'Alertas',
  },

  // Pantalla 3

  pv105pageName: {
    path: 'page.name',
    value: 'CreaTuAlerta',
  },
  pv105siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv105pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv105subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv105pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv105pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv105customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv105customTransactionsimulationvalue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv105internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv105errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv105transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv105productCategory: {
    path: 'transaction.details.productcategory',
    value: null,
  },
  pv105transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv105transactionPaymentMethod: {
    path: 'transaction.details.paymentmethod',
    value: null,
  },
  pv105transactionName: {
    path: 'transaction.name',
    value: 'Alertas',
  },

  // Pantalla 4

  pv106pageName: {
    path: 'page.name',
    value: 'Confirmacion',
  },
  pv106siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv106pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv106subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv106pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv106pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv106customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv106customTransactionValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv106internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv106errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv106transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv106productCategory: {
    path: 'transaction.details.productcategory',
    value: null,
  },
  pv106transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv106transactionPaymentMethod: {
    path: 'transaction.details.paymentmethod',
    value: null,
  },
  pv106transactionName: {
    path: 'transaction.name',
    value: 'Alertas',
  },

  // Pantallas ServiciosSolicitudConfigurar - SeguridadPregunta

  // Pantalla 1

  pv107pageName: {
    path: 'page.name',
    value: 'CambiarPreguntas',
  },
  pv107siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv107pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv107subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv107pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv107pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv107customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv107internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv107errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv107transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv107transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Seguridad',
  },
  pv107transactionName: {
    path: 'transaction.name',
    value: 'CambiarPreguntas',
  },

  // Pantalla 2

  pv108pageName: {
    path: 'page.name',
    value: 'SeleccionPreguntas',
  },
  pv108siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv108pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv108subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv108pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv108pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv108customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv108internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv108errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv108transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv108transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Seguridad',
  },
  pv108transactionName: {
    path: 'transaction.name',
    value: 'CambiarPreguntas',
  },

  // Pantalla 3

  pv109pageName: {
    path: 'page.name',
    value: 'ConfirmacionCambio',
  },
  pv109siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv109pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv109subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv109pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv109pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv109customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv109internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv109errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv109transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv109transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Seguridad',
  },
  pv109transactionName: {
    path: 'transaction.name',
    value: 'CambiarPreguntas',
  },

  // Pantallas CampanasOfertaProductosOfertar - Redirect Landing
  // Pantalla 1

  pv110pageName: {
    path: 'page.name',
    value: 'ModalLanding',
  },
  pv110siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv110pageFamily: {
    path: 'page.family',
    value: 'Campanas',
  },
  pv110subFamily: {
    path: 'page.subfamily',
    value: 'OfertaProductos',
  },
  pv110pageAction: {
    path: 'page.action',
    value: 'Ofertar',
  },
  pv110pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv110internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv110errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv110productCategory: {
    path: 'transaction.details.productcategory',
    value: 'OfertaRedirectLanding',
  },
  pv110transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },

  // Pantallas ServiciosSolicitudConfigurar - AgregarIP

  // Pantalla 1

  pv111pageName: {
    path: 'page.name',
    value: 'HomeIPFija',
  },
  pv111siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv111pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv111subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv111pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv111pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv111internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv111errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv111transactionName: {
    path: 'transaction.name',
    value: 'AgregarIPFija',
  },

  // Pantalla 2

  pv112pageName: {
    path: 'page.name',
    value: 'SeguridadAgregarIP',
  },
  pv112siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv112pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv112subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv112pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv112pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv112customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv112internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv112errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv112transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv112transactionName: {
    path: 'transaction.name',
    value: 'AgregarIPFija',
  },

  // Pantalla 3

  pv113pageName: {
    path: 'page.name',
    value: 'ConfirmacionAgregarIP',
  },
  pv113siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv113pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv113subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv113pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv113pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv113customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv113internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv113errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv113transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv113transactionName: {
    path: 'transaction.name',
    value: 'AgregarIPFija',
  },

  // Pantalla 4

  pv114pageName: {
    path: 'page.name',
    value: 'HomeRangoIP',
  },
  pv114siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv114pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv114subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv114pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv114pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv114internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv114errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv114transactionName: {
    path: 'transaction.name',
    value: 'AgregarRangoIP',
  },

  // Pantalla 5

  pv115pageName: {
    path: 'page.name',
    value: 'AgregarRangoIP',
  },
  pv115siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv115pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv115subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv115pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv115pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv115customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv115internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv115errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv115transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv115transactionName: {
    path: 'transaction.name',
    value: 'AgregarRangoIP',
  },

  // Pantalla 6

  pv116pageName: {
    path: 'page.name',
    value: 'ConfirmacionAgregarRangoIP',
  },
  pv116siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv116pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv116subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv116pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv116pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv116customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv116internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv116errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv116transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv116transactionName: {
    path: 'transaction.name',
    value: 'AgregarRangoIP',
  },

  // Pantallas AreaComunHomeConsultar - Vitrinas terminos y condiciones

  // Pantalla 1

  pv117pageName: {
    path: 'page.name',
    value: 'Consultar',
  },
  pv117siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv117pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv117subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv117pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv117pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv117internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv117errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantallas ServiciosSolicitudConfigurar - Seguridad Clave

  // Pantalla 1

  pv118pageName: {
    path: 'page.name',
    value: 'CambiarClave',
  },
  pv118siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv118pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv118subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv118pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv118pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv118internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv118errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv118productCategory: {
    path: 'transaction.details.productcategory',
    value: 'Seguridad',
  },
  pv118transactionName: {
    path: 'transaction.name',
    value: 'CambiarClave',
  },

  // Pantalla 2

  pv119pageName: {
    path: 'page.name',
    value: 'ConfirmarCambioClave',
  },
  pv119siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv119pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv119subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv119pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv119pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv119customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv119internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv119errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv119transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv119productCategory: {
    path: 'transaction.details.productcategory',
    value: 'Seguridad',
  },
  pv119transactionName: {
    path: 'transaction.name',
    value: 'CambiarClave',
  },

  // Pantalla 3

  pv120pageName: {
    path: 'page.name',
    value: 'BloquearClave',
  },
  pv120siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv120pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv120subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv120pageAction: {
    path: 'page.action',
    value: 'Configurar',
  },
  pv120pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv120internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv120errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv120transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'BloquearClave',
  },
  pv120productCategory: {
    path: 'transaction.details.productcategory',
    value: 'Seguridad',
  },

  // Pantallas TransferenciasBancosLocaisConsultar - Inscribir
  // Pantalla 1

  pv122pageName: {
    path: 'page.name',
    value: 'RegistrarDatosCuentas',
  },
  pv122siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv122pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv122subFamily: {
    path: 'page.subfamily',
    value: 'BancosLocais',
  },
  pv122pageAction: {
    path: 'page.action',
    value: 'Agendar',
  },
  pv122pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv122customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv122internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv122errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv122transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv122transactionName: {
    path: 'transaction.name',
    value: 'InscribirCuentasTransferencias',
  },

  // Pantalla 2

  pv123pageName: {
    path: 'page.name',
    value: 'ResumenDatosCuenta',
  },
  pv123siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv123pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv123subFamily: {
    path: 'page.subfamily',
    value: 'BancosLocais',
  },
  pv123pageAction: {
    path: 'page.action',
    value: 'Agendar',
  },
  pv123pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv123customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv123internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv123errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv123transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv123transactionDestinationbank: {
    path: 'transaction.details.destinationbank',
    value: null,
  },
  pv123transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv123transactionName: {
    path: 'transaction.name',
    value: 'InscribirCuentasTransferencias',
  },

  // Pantalla 3

  pv124pageName: {
    path: 'page.name',
    value: 'ConfirmarTransferencia',
  },
  pv124siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv124pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv124subFamily: {
    path: 'page.subfamily',
    value: 'BancosLocais',
  },
  pv124pageAction: {
    path: 'page.action',
    value: 'Agendar',
  },
  pv124pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv124customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv124internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv124errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv124transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv124transactionDestinationbank: {
    path: 'transaction.details.destinationbank',
    value: null,
  },
  pv124transactionDestinationAccounttype: {
    path: 'transaction.details.destinationaccounttype',
    value: null,
  },
  pv124transactionName: {
    path: 'transaction.name',
    value: 'InscribirCuentasTransferencias',
  },

  // Pantallas TransferenciasBancosLocaisConsultar - Home

  // Pantalla 1

  pv125pageName: {
    path: 'page.name',
    value: 'HistorialTransferenciasRealizadas',
  },
  pv125siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv125pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv125subFamily: {
    path: 'page.subfamily',
    value: 'BancosLocais',
  },
  pv125pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv125pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv125internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv125errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv125transactionName: {
    path: 'transaction.name',
    value: 'HistorialTransferencias',
  },

  // Pantalla 2

  pv126pageName: {
    path: 'page.name',
    value: 'HistorialTransferenciasRecibidas',
  },
  pv126siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv126pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv126subFamily: {
    path: 'page.subfamily',
    value: 'BancosLocais',
  },
  pv126pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv126pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv126internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv126errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv126transactionName: {
    path: 'transaction.name',
    value: 'HistorialTransferencias',
  },

  // Pantalla 3

  pv127pageName: {
    path: 'page.name',
    value: 'TransferenciasProgramadas',
  },
  pv127siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv127pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv127subFamily: {
    path: 'page.subfamily',
    value: 'BancosLocais',
  },
  pv127pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv127pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv127internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv127errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv127transactionName: {
    path: 'transaction.name',
    value: 'TransferenciasProgramadas',
  },

  // Pantalla 4

  pv128pageName: {
    path: 'page.name',
    value: 'TransferenciasProgramadasEjecutadas',
  },
  pv128siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv128pageFamily: {
    path: 'page.family',
    value: 'Transferencias',
  },
  pv128subFamily: {
    path: 'page.subfamily',
    value: 'BancosLocais',
  },
  pv128pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv128pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv128internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv128errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv128transactionName: {
    path: 'transaction.name',
    value: 'TransferenciasProgramadas',
  },

  // Pantallas AreaComunHomeConsultar - Home Productos

  // Pantalla 1

  pv129pageName: {
    path: 'page.name',
    value: 'HomeProductos',
  },
  pv129siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv129pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv129subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv129pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv129pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv129internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv129errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv129transactionName: {
    path: 'transaction.name',
    value: 'ConsultaProductos',
  },

  // Pantallas InversionesDepositosPlazoFijoCambiar - Condiciones CDT

  // Pantalla 1

  pv130pageName: {
    path: 'page.name',
    value: 'ResumenCDTVirtual',
  },
  pv130siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv130pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv130subFamily: {
    path: 'page.subfamily',
    value: 'DepositosPlazoFijo',
  },
  pv130pageAction: {
    path: 'page.action',
    value: 'Cambiar',
  },
  pv130pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv130internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv130errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv130transactionName: {
    path: 'transaction.name',
    value: 'CambiarCondicionesCDT',
  },

  // Pantalla 2

  pv131pageName: {
    path: 'page.name',
    value: 'ModificarCondicionesCDTVirtual',
  },
  pv131siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv131pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv131subFamily: {
    path: 'page.subfamily',
    value: 'DepositosPlazoFijo',
  },
  pv131pageAction: {
    path: 'page.action',
    value: 'Cambiar',
  },
  pv131pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv131customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv131internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv131errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv131transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv131transactionName: {
    path: 'transaction.name',
    value: 'CambiarCondicionesCDT',
  },

  // Pantalla 3

  pv132pageName: {
    path: 'page.name',
    value: 'ResumenModificacionCDTVirtual',
  },
  pv132siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv132pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv132subFamily: {
    path: 'page.subfamily',
    value: 'DepositosPlazoFijo',
  },
  pv132pageAction: {
    path: 'page.action',
    value: 'Cambiar',
  },
  pv132pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv132customTransactioncheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv132internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv132errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv132transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv132transactionName: {
    path: 'transaction.name',
    value: 'CambiarCondicionesCDT',
  },

  // Pantalla 4

  pv133pageName: {
    path: 'page.name',
    value: 'ConfirmacionModificacionCDTVirtual',
  },
  pv133siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv133pageFamily: {
    path: 'page.family',
    value: 'Inversiones',
  },
  pv133subFamily: {
    path: 'page.subfamily',
    value: 'DepositosPlazoFijo',
  },
  pv133pageAction: {
    path: 'page.action',
    value: 'Cambiar',
  },
  pv133pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv133customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv133internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv133errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv133transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv133transactionName: {
    path: 'transaction.name',
    value: 'CambiarCondicionesCDT',
  },

  // Pantallas AreaComunHomeConsultar - Detalle Producto

  pv135pageName: {
    path: 'page.name',
    value: 'ResumenProducto',
  },
  pv135siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  pv135pageFamily: {
    path: 'page.family',
    value: 'AreaComun',
  },
  pv135subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv135pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv135pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv135internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv135errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv135transactionName: {
    path: 'transaction.name',
    value: 'ConsultaProductos',
  },
  pv135productcategory: {
    path: 'transaction.details.productcategory',
    value: null,
  },

};

export const EVENT = {
  customCategory: {
    module: {
      body: 'Body',
      carousel: 'Carousel',
      footer: 'Footer',
      header: 'Header',
      lightbox: 'Lightbox',
      menu: 'Menu',
    },
    type: {
      accordion: 'Accordion',
      arrow: 'Arrow',
      button: 'Button',
      card: 'Card',
      checkbox: 'Checkbox',
      content: 'Content',
      dropdown: 'Dropdown',
      image: 'Image',
      link: 'Link',
      pagination: 'Pagination',
      radio: 'Radio',
      tab: 'Tab',
      textField: 'TextField',
      tooltip: 'Tooltip',
      warning: 'Warning',
    },
    position: {
      bottom: 'Bottom',
      center: 'Center',
      left: 'Left',
      rigt: 'Right',
      top: 'Top',
    },
  },
  customAction: {
    click: 'Click',
    close: 'Close',
    download: 'Download',
    hide: 'Hide',
    open: 'Open',
    print: 'Print',
    scroll: 'Scroll',
    search: 'Search',
    share: 'Share',
    show: 'Show',
    swipeToLeft: 'SwipeToLeft',
    swipeToRigth: 'SwipeToRigth',
  },
  // Eventos de AreaComunRegistroHabilitar - Registro

  // Eventos Pantalla 1
  pv134E1customLabel: 'Registrate',

  // Eventos Pantalla 2
  pv1E1customLabel: 'ErrorInfoErradaRegistro',
  pv1E1setData: {
    pv1E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv1E2customLabel: 'ErrorUsuarioRegistradoRegistro',
  pv1E2setData: {
    pv1E2transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv1E3customLabel: 'ErrorCaptchaErradoRegistro',
  pv1E3setData: {
    pv1E3transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv1E4customLabel: 'MensajeUsuarioSuperBloqueadoRegistro',
  pv1E4setData: {
    pv1E4transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv1E5customLabel: 'ErrorUsuarioPendienteActivacionRegistro',
  pv1E5setData: {
    pv1E5transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv1E6customLabel: 'Cancelar',
  pv1E6setData: {
    pv1E6transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },

  // Eventos Pantalla 3
  pv2E1customLabel: 'ConsultaTerminosCondiciones',
  pv2E1setData: {
    pv2E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv2E2customLabel: 'Cancelar',
  pv2E2setData: {
    pv2E2transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  // Eventos Pantalla 4
  pv3E1customLabel: 'Cancelar',
  pv3E1setData: {
    pv3E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  // Eventos Pantalla 9
  pv137E1customLabel: 'Cancelar',
  pv137E1setData: {
    pv137E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  // Eventos Pantalla 5
  pv4E1customLabel: 'ErrorUsuarioRegistrado',
  pv4E1setData: {
    pv4E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv4E2customLabel: 'Cancelar',
  pv4E2setData: {
    pv4E2transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  // Eventos pantalla 6
  pv5E1customLabel: 'Salir',
  pv5E1setData: {
    pv5E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  // Eventos Pantalla 7
  pv6E1customLabel: 'ReenviarCodigo',
  pv6E1setData: {
    pv6E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv6E2customLabel: 'TengoProblemas',
  pv6E2setData: {
    pv6E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv6E3customLabel: 'Cancelar',
  pv6E3setData: {
    pv6E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv6E4customLabel: 'ErrorCodigoErrado',
  pv6E4setData: {
    pv6E4transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv6E5customLabel: 'ErrorOTPVencido',
  pv6E5setData: {
    pv6E5transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv6E6customLabel: 'UsuarioBloqueadoOTP',
  pv6E6setData: {
    pv6E6transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },
  pv6E7customLabel: 'TengoProblemasOTP',
  pv6E7setData: {
    pv6E7transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },

  // Eventos pantalla 8
  pv7E1customLabel: 'Ingresar',
  pv7E1setData: {
    pv7E1transactionName: {
      path: 'transaction.name',
      value: 'Registro',
    },
  },

  // Eventos documento AreaComunRegistroLoguear - JornadaAcceso
  // Eventos Pantalla 1
  pv8E1customLabel: 'SeleccionIngles',
  pv8E2customLabel: 'Banner',
  pv8E3customLabel: 'MenuCentral',
  pv8E4customLabel: 'MenuLateral',
  pv8E5customLabel: null,
  pv8E6customLabel: 'IngresarContrasena',
  pv8E6setData: {
    pv8E6transactionName: {
      path: 'transaction.name',
      value: 'JornadaAcceso',
    },
    pv8E6transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: '1',
    },
  },
  pv8E6events: {
    name: 'transactionstep01',
    value: 'transactionstep01',
  },
  pv8E7customLabel: 'ValidarContrasena',
  pv8E7setData: {
    pv8E7transactionName: {
      path: 'transaction.name',
      value: 'JornadaAcceso',
    },
    pv8E7transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: '2',
    },
  },
  pv8E7events: {
    name: 'transactionstep02',
    value: 'transactionstep02',
  },
  pv8E8customLabel: 'ErrorIdentificacion',
  pv8E9customLabel: 'PreguntaSeguridad',
  pv8E9setData: {
    pv8E9transactionName: {
      path: 'transaction.name',
      value: 'JornadaAcceso',
    },
    pv8E9transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: '3',
    },
  },
  pv8E9events: {
    name: 'transactionstep03',
    value: 'transactionstep03',
  },

  pv8E10customLabel: 'ValidarRespuesta',
  pv8E10setData: {
    pv8E10transactionName: {
      path: 'transaction.name',
      value: 'JornadaAcceso',
    },
    pv8E10transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: '4',
    },
  },
  pv8E10events: {
    name: 'transactionstep04',
    value: 'transactionstep04',
  },
  pv8E11customLabel: 'ErrorDatosIncorrectos',

  // Eventos de documento AreaComunHomeConsultar  -  Home
  // Eventos Pantalla 1

  pv10E1customLabel: 'ShowBanner',

  pv10E2customLabel: 'ClickBanner',
  pv10E2setData: {
    pv10E2transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  pv10E3customLabel: 'Warning',
  pv10E3setData: {
    pv10E3transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  pv10E4customLabel: 'MenuLateral',

  pv10E5customLabel: 'Warning',
  pv10E5setData: {
    pv10E5visitoragencystoreid: {
      path: 'visitor.agencystoreid',
      value: null,
    },
  },

  pv10E6customLabel: 'VitrinaLateral',
  pv10E6setData: {
    pv10E6transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv10E6visitoragencystoreid: {
      path: 'visitor.agencystoreid',
      value: null,
    },
  },

  pv10E7customLabel: 'BotonSeguros',

  pv10E8customLabel: 'SegurosConoceMas',
  pv10E9customLabel: 'PopUpFinanciamiento',
  pv10E10customLabel: 'PopUpFinanciamiento | ConoceOferta',
  pv10E11customLabel: 'PopUpFinanciamiento | NoMeInteresa',

  // Eventos de documento CampanasOfertaProductosOfertar  -  AprobadosEnFirme

  // Eventos Pantalla 1

  pv11E1customLabel: 'ProductoGustaMas',
  pv11E1setData: {
    pv11E1transactionName: {
      path: 'transaction.name',
      value: 'AprobadosEnFirme',
    },
  },
  pv11E2customLabel: 'Terminos&CondLectura',
  pv11E2setData: {
    pv11E2transactionName: {
      path: 'transaction.name',
      value: 'AprobadosEnFirme',
    },
  },

  // Eventos pantalla 2
  pv12E1customLabel: 'Contacto',
  pv12E1setData: {
    pv12E1transactionName: {
      path: 'transaction.name',
      value: 'AprobadosEnFirme',
    },
  },
  pv12E2customLabel: 'FechaFacturacion',
  pv12E2setData: {
    pv12E2transactionName: {
      path: 'transaction.name',
      value: 'AprobadosEnFirme',
    },
  },
  pv12E3customLabel: 'ConfirmacionImpresion',
  pv12E3setData: {
    pv12E3transactionName: {
      path: 'transaction.name',
      value: 'AprobadosEnFirme',
    },
  },
  pv12E4customLabel: 'Confirmar',
  pv12E4setData: {
    pv12E4transactionName: {
      path: 'transaction.name',
      value: 'AprobadosEnFirme',
    },
    pv12E4transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: 'Complete',
    },
  },
  pv12E4events: {
    name: 'transactioncomplete',
    value: '1',
  },

  // Eventos de documento Inversiones Ahorro programado Contratar - Ahorro programado

  // Eventos Pantalla 1

  pv13E1customLabel: 'VerCondicionesAhorroProgramado',
  pv13E1setData: {
    pv13E1transactionName: {
      path: 'transaction.name',
      value: 'AhorroProgramado',
    },
  },

  pv13E2customLabel: 'SeleccionarCuentaOrigen',
  pv13E2setData: {
    pv13E2transactionName: {
      path: 'transaction.name',
      value: 'AhorroProgramado',
    },
  },

  pv13E3customLabel: 'SelecionarFechaPrimerDebito',
  pv13E3setData: {
    pv13E3transactionName: {
      path: 'transaction.name',
      value: 'AhorroProgramado',
    },
  },

  pv13E4customLabel: 'MasInformacion',
  pv13E4setData: {
    pv13E4transactionName: {
      path: 'transaction.name',
      value: 'AhorroProgramado',
    },
  },

  // Eventos Pantalla 2

  pv14E1customLabel: 'LecturaTermCond',
  pv14E1setData: {
    pv14E1transactionName: {
      path: 'transaction.name',
      value: 'AhorroProgramado',
    },
  },
  pv14E2customLabel: 'LecturaVTU',
  pv14E2setData: {
    pv14E2transactionName: {
      path: 'transaction.name',
      value: 'AhorroProgramado',
    },
  },

  // Eventos Pantalla 3
  pv15E1customLabel: 'Descargar',
  pv15E1setData: {
    pv15E1transactionName: {
      path: 'transaction.name',
      value: 'AhorroProgramado',
    },
  },

  // Eventos de documento Inversiones Deposito Plazo Fijo Contratar  - Itau Rentable

  // Eventos Pantalla  1

  pv16E1customLabel: 'VerCondicionesSimuladorItauRentable',
  pv16E1setData: {
    pv16E1transactionName: {
      path: 'transaction.name',
      value: 'ItauRentable',
    },
  },

  pv16E2customLabel: 'SeleccionarCuentaOrigenItauRentable',
  pv16E2setData: {
    pv16E2transactionName: {
      path: 'transaction.name',
      value: 'ItauRentable',
    },
  },

  pv16E3customLabel: 'Continuar',
  pv16E3setData: {
    pv16E3transactionDetailsOriginaccounttype: {
      path: 'transaction.details.originaccounttype',
      value: null,
    },
    pv16E3transactionDetailsTax: {
      path: 'transaction.details.tax',
      value: null,
    },
    pv16E3transactionDetailsInstallmentsterm: {
      path: 'transaction.details.installmentsterm',
      value: null,
    },
    pv16E3transactionName: {
      path: 'transaction.name',
      value: 'ItauRentable',
    },
  },

  // Eventos Pantalla  2

  pv17E1customLabel: 'LecturaTerm&Cond',
  pv17E1setData: {
    pv17E1transactionName: {
      path: 'transaction.name',
      value: 'ItauRentable',
    },
  },
  pv17E2customLabel: 'LecturaVTU',
  pv17E2setData: {
    pv17E2transactionName: {
      path: 'transaction.name',
      value: 'ItauRentable',
    },
  },

  // Eventos Pantalla 3
  pv18E1customLabel: 'Descargar',
  pv18E1setData: {
    pv18E1transactionName: {
      path: 'transaction.name',
      value: 'ItauRentable',
    },
  },

  // Eventos de documento Inversiones Home Agregar  - CDT Virtual
  // Eventos pantalla 1

  pv19E1customLabel: null,

  // Eventos pantalla 2

  pv20E1customLabel: 'CDTVirtual',
  pv20E1setData: {
    pv20E1transactionName: {
      path: 'transaction.name',
      value: 'CDTVirtual',
    },
  },

  // Eventos pantalla 4

  pv22E1customLabel: 'LecturaTermAndCond',
  pv22E1setData: {
    pv22E1transactionName: {
      path: 'transaction.name',
      value: 'CDTVirtual',
    },
  },

  // Eventos Pantalla de documento Tarjetas Alimentacion Solicitar
  // Eventos Pantalla 3

  pv29E1customLabel: 'GuardarComprobante',
  pv29E1setData: {
    pv29E1transactionName: {
      path: 'transaction.name',
      value: 'Avances',
    },
  },

  // Eventos Pantalla de documento Area Comun Registro Habilitar - Desbloqueo clave
  // Eventos Pantalla 1

  pv30E1customLabel: 'DesbloquearUsuario',
  pv30E1setData: {
    pv30E1transactionName: {
      path: 'transaction.name',
      value: 'Desbloqueo',
    },
  },

  // Eventos Pantalla 2

  pv31E1customLabel: 'Cancelar',
  pv31E1setData: {
    pv31E1transactionName: {
      path: 'transaction.name',
      value: 'Desbloqueo',
    },
  },
  pv31E2customLabel: 'ErrorInfoErradaDesbloqueo',
  pv31E2errorname: 'ErrorInfoErradaDesbloqueo',
  pv31E2setData: {
    pv31E2transactionName: {
      path: 'transaction.name',
      value: 'Desbloqueo',
    },
  },
  pv31E3customLabel: 'ErrorUsuarioRegistradoDesbloqueo',
  pv31E3errorname: 'ErrorUsuarioRegistradoDesbloqueo',
  pv31E3setData: {
    pv31E3transactionName: {
      path: 'transaction.name',
      value: 'Desbloqueo',
    },
  },
  pv31E4customLabel: 'ErrorCaptchaErradoDesbloqueo',
  pv31E4errorname: 'ErrorCaptchaErradoDesbloqueo',
  pv31E4setData: {
    pv31E4transactionName: {
      path: 'transaction.name',
      value: 'Desbloqueo',
    },
  },
  pv31E5customLabel: 'MensajeUsuarioSuperBloqueadoDesbloqueo',
  pv31E5errorname: 'MensajeUsuarioSuperBloqueadoDesbloqueo',
  pv31E5setData: {
    pv31E5transactionName: {
      path: 'transaction.name',
      value: 'Desbloqueo',
    },
  },

  // Eventos pantalla 3

  pv32E1customLabel: 'Cancelar',
  pv32E1setData: {
    pv32E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv32E2customLabel: 'ErrorUsuario',
  pv32E2setData: {
    pv32E2transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },

  // Eventos Pantalla 4

  pv33E1customLabel: 'Cancelar',
  pv33E1setData: {
    pv33E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv33E2customLabel: 'ErrorPreguntasClave',
  pv33E2errorname: 'ErrorPreguntasClave',
  pv33E2setData: {
    pv33E2transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },

  // Pantalla 5

  pv34E1customLabel: 'Cancelar',
  pv34E1setData: {
    pv34E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv34E2customLabel: 'ReenviarCodigo',
  pv34E2setData: {
    pv34E2transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv34E3customLabel: 'TengoProblemas',
  pv34E3setData: {
    pv34E3transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv34E4customLabel: 'CodigoOTPErradoClave',
  pv34E4errorname: 'CodigoOTPErradoClave',
  pv34E4setData: {
    pv34E4transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv34E5customLabel: 'CodigoOTPVencidoClave',
  pv34E5errorname: 'CodigoOTPVencidoClave',
  pv34E5setData: {
    pv34E5transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv34E6customLabel: 'UsuarioBLoqueadoOTPClave',
  pv34E6errorname: 'UsuarioBLoqueadoOTPClave',
  pv34E6setData: {
    pv34E6transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv34E7customLabel: 'TengoProblemasOTPClave',
  pv34E7setData: {
    pv34E7transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },

  // Eventos Pantalla 6

  pv35E1customLabel: 'Cancelar',
  pv35E1setData: {
    pv35E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },
  pv35E2customLabel: 'Continuar',
  pv35E2setData: {
    pv35E2transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },

  // Eventos pantalla 7

  pv36E1customLabel: 'Ingresar',
  pv36E1setData: {
    pv36E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoClave',
    },
  },

  // Eventos Pantallas de ServiciosSolicitudConfigurar - Actualización de datos
  // Eventos Pantalla 1
  pv37E1customLabel: 'PreguntaSeguridad',
  pv37E1setData: {
    pv37E1transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: '1',
    },
    pv37E1transactionName: {
      path: 'transaction.name',
      value: 'ActualizacionDatos',
    },
  },
  pv37E1events: {
    name: 'transactionstep01',
    value: '1',
  },

  // Eventos Pantalla 3
  pv39E1customLabel: 'PreguntaSeguridadConfirmacion',
  pv39E1setData: {
    pv39E1transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: 'Checkout',
    },
    pv39E1transactionName: {
      path: 'transaction.name',
      value: 'ActualizacionDatos',
    },
  },
  pv39E1events: {
    name: 'transactioncheckout',
    value: '1',
  },

  // Eventos Pantalla 4
  pv40E1customLabel: 'Finalizar',
  pv40E1setData: {
    pv40E1transactionName: {
      path: 'transaction.name',
      value: 'ActualizacionDatos',
    },
  },

  // Eventos Pantallas de PagamentosFacturaPagar - Pago Prestamo
  // Eventos Pantalla 1
  pv44E1customLabel: 'FondoOtrosBancos',

  pv44E2customLabel: 'Alerta',
  pv44E2setData: {
    pv44E2transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  // Eventos Pantalla 2
  pv45E1customLabel: 'Alerta',
  pv45E1setData: {
    pv45E1transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  pv45E2customLabel: 'BotonPSE',

  // Eventos Pantallas de PagamentosServiciosPagar - Credito Rotativo
  // Eventos Pantalla 3
  pv49E1customLabel: 'GuardarComprobante',
  pv49E1setData: {
    pv49E1transactionName: {
      path: 'transaction.name',
      value: 'CreditoRotativo',
    },
  },

  // Eventos Pantallas de TarjetasCreditoBloquear - Bloqueo Tarjeta
  // Eventos Pantalla 3
  pv59E1customLabel: 'GuardarComprobante',
  pv59E1setData: {
    pv59E1transactionName: {
      path: 'transaction.name',
      value: 'BloquearTarjeta',
    },
  },

  // Eventos Pantallas de PagamentosFacturaPagar - Domiciliación Pagos
  // Eventos Pantalla 3
  pv62E1customLabel: 'GuardarComprobante',
  pv62E1setData: {
    pv62E1transactionName: {
      path: 'transaction.name',
      value: 'PagoFactura',
    },
  },

  // Eventos Pantallas de PagamentosFacturaPagar - Domiciliación Inscribir
  // Eventos Pantalla 3
  pv65E1customLabel: 'PreguntaSeguridad',
  pv65E1setData: {
    pv65E1transactionName: {
      path: 'transaction.name',
      value: 'InscripcionFactura',
    },
  },

  // Eventos Pantallas de AreaComunRegistroHabilitar - Desbloqueo Pregunta
  // Eventos Pantalla 1
  pv76E1customLabel: 'Cancelar',
  pv76E1setData: {
    pv76E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  // Eventos Pantalla 2
  pv77E1customLabel: 'Cancelar',
  pv77E1setData: {
    pv77E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv77E2customLabel: 'ErrorInfoErradaUsuarioClave',
  pv77E2setData: {
    pv77E2transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv77E3customLabel: 'MensajeUsuarioSuperBloqueadoPreguntas',
  pv77E3setData: {
    pv77E3transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  // Eventos Pantalla 3
  pv78E1customLabel: 'Cancelar',
  pv78E1setData: {
    pv78E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv78E2customLabel: 'ReenviarCodigo',
  pv78E2setData: {
    pv78E2transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv78E3customLabel: 'TengoProblemas',
  pv78E3setData: {
    pv78E3transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv78E4customLabel: 'CodigoOTPErradoPreguntas',
  pv78E4setData: {
    pv78E4transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv78E5customLabel: 'CodigoOTPVencidoPreguntas',
  pv78E5setData: {
    pv78E5transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv78E6customLabel: 'UsuarioBLoqueadoOTPPreguntas',
  pv78E6setData: {
    pv78E6transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv78E7customLabel: 'TengoProblemasOTPPreguntas',
  pv78E7setData: {
    pv78E7transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  // Eventos Pantalla 4
  pv79E1customLabel: 'Cancelar',
  pv79E1setData: {
    pv79E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  pv79E2customLabel: 'Continuar',
  pv79E2setData: {
    pv79E2transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  // Eventos Pantalla 5
  pv80E1customLabel: 'Ingresar',
  pv80E1setData: {
    pv80E1transactionName: {
      path: 'transaction.name',
      value: 'DesbloqueoPreguntas',
    },
  },

  // Eventos de ServiciosCertificacionConsultar - Extractos y certificados
  // Eventos Pantalla 1

  pv81E1customLabel: null,

  pv81E2customLabel: 'Consulta',
  pv81E2setData: {
    pv81E2transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  // Eventos de Pantallas de PagamentosServiciosPagar - Inscribir TC otros bancos
  // Eventos Pantalla 3
  pv84E1customLabel: 'PreguntaSeguridad',
  pv84E1setData: {
    pv84E1transactionName: {
      path: 'transaction.name',
      value: 'PagosInscribirTarjetas',
    },
  },

  pv84E2customLabel: 'ContinuarPreguntasSeguridad',
  pv84E2setData: {
    pv84E2transactionName: {
      path: 'transaction.name',
      value: 'PagosInscribirTarjetas',
    },
  },

  // Eventos de Pantallas de ServicioSolicitudConfigurar - Solicitud
  // Eventos Pantalla 1
  pv86E1customLabel: 'Solicitud',
  pv86E2customLabel: 'CancelarSolicitud',
  pv86E3customLabel: 'EnviarSolicitud',
  pv86E3setData: {
    pv83E3transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },
  pv86E4customLabel: 'VerDetalleSolicitud',

  // Eventos de TransferenciasCuentasVirtualesTransferir - TransfiYa

  // Eventos Pantalla 1
  pv90E1customLabel: 'Transferir',
  pv90E1setData: {
    pv90E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E1transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E2customLabel: 'ActualizarDatos',
  pv90E2setData: {
    pv90E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E2transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E3customLabel: 'ContinuarDatos',
  pv90E3setData: {
    pv90E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E3transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E8customLabel: 'PreguntaSeguridad',
  pv90E8setData: {
    pv90E8transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E8transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E9customLabel: 'SeguridadBotonContinuar',
  pv90E9setData: {
    pv90E9transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E9transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E10customLabel: 'ActualizarDatos',
  pv90E10setData: {
    pv90E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E10transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E11customLabel: 'Actualizar',
  pv90E11setData: {
    pv90E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E11transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E12customLabel: 'Cancelar',
  pv90E12setData: {
    pv90E12transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E12transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E13customLabel: 'PreguntaSeguridadConfirmacion',
  pv90E13setData: {
    pv90E13transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E13transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E14customLabel: 'ContinuarConfirmacion',
  pv90E14setData: {
    pv90E14transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E14transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E15customLabel: 'ConfirmacionDatos',
  pv90E15setData: {
    pv90E15transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E15transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E7customLabel: 'Finalizar',
  pv90E7setData: {
    pv90E7transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ActualizarDatos',
    },
    pv90E7transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv90E4customLabel: 'Transferir',
  pv90E5customLabel: 'OpcionRecibir',
  pv90E6customLabel: 'Rechazar',

  // Eventos Pantalla 2
  pv91E1customLabel: 'Cancelar',
  pv91E1setData: {
    pv91E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Transferir',
    },
    pv91E1transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  // Eventos Pantalla 3
  pv92E1customLabel: 'Cancelar',
  pv92E1setData: {
    pv92E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Transferir',
    },
    pv92E1transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv92E2customLabel: 'PreguntaSeguridad',
  pv92E2setData: {
    pv92E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Transferir',
    },
    pv92E2transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv92E3customLabel: 'PreguntaSeguridadContinuar',
  pv92E3setData: {
    pv92E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Transferir',
    },
    pv92E3transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  // Eventos Pantalla 4
  pv93E1customLabel: 'FinalizarEnviarTrasnferencia',
  pv93E1setData: {
    pv93E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Transferir',
    },
    pv93E1transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv93E2customLabel: 'NuevaTransferencia',
  pv93E2setData: {
    pv93E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Transferir',
    },
    pv93E2transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  // Eventos Pantalla 5
  pv94E1customLabel: 'Salir',
  pv94E1setData: {
    pv94E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RecibirTransferencia',
    },
    pv94E1transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv94E2customLabel: 'Recibir',
  pv94E2setData: {
    pv94E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RecibirTransferencia',
    },
    pv94E2transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  // Eventos Pantalla 6
  pv95E1customLabel: 'Finalizar',
  pv95E1setData: {
    pv95E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RecibirTransferencia',
    },
    pv95E1transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  // Eventos Pantalla 7
  pv96E1customLabel: 'Rechazar',
  pv96E1setData: {
    pv96E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RechazarTransferencia',
    },
    pv96E1transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  pv96E2customLabel: 'Salir',
  pv96E2setData: {
    pv96E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RechazarTransferencia',
    },
    pv96E2transactionName: {
      path: 'transaction.name',
      value: 'TransfiYa',
    },
  },

  // Eventos de Pantallas ServiciosSolicitudConfigurar - SeguridadPregunta

  // Eventos Pantalla 1
  pv107E1customLabel: 'PreguntaSeguridad',
  pv107E1setData: {
    pv107E1transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: 'Seguridad',
    },
    pv107E1transactionName: {
      path: 'transaction.name',
      value: 'CambiarPreguntas',
    },
  },

  pv107E2customLabel: 'Continuar',
  pv107E2setData: {
    pv107E2transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: 'Seguridad',
    },
    pv107E2transactionName: {
      path: 'transaction.name',
      value: 'CambiarPreguntas',
    },
  },

  // Eventos de CampanasOfertaProductosOfertar - Redirect Landing

  // Eventos Pantalla 1
  pv110E1customLabel: 'Solicitar',
  pv110E1setData: {
    pv110E1transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv110E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'OfertaRedirectLanding',
    },
  },

  pv110E2customLabel: 'LecturaTermAndCond',
  pv110E2setData: {
    pv110E2transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv110E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'OfertaRedirectLanding',
    },
  },

  pv110E3customLabel: 'AceptarTerminos',
  pv110E3setData: {
    pv110E3transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv110E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'OfertaRedirectLanding',
    },
  },

  // Eventos de ServiciosSolicitudConfigurar - AgregarIP

  // Eventos Pantalla 2
  pv112E1customLabel: 'PreguntaSeguridad',
  pv112E1setData: {
    pv112E1transactionName: {
      path: 'transaction.name',
      value: 'AgregarIPFija',
    },
    pv112E1transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: 'Checkout',
    },
  },
  pv112E1events: {
    name: 'transactioncheckout',
    value: '1',
  },

  // Eventos Pantalla 5
  pv115E1customLabel: 'PreguntaSeguridad',
  pv115E1setData: {
    pv115E1transactionName: {
      path: 'transaction.name',
      value: 'AgregarRangoIP',
    },
    pv115E1transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: 'Checkout',
    },
  },
  pv115E1events: {
    name: 'transactioncheckout',
    value: '1',
  },

  // Eventos de Pantallas AreaComunHomeConsultar - Vitrinas terminos y condiciones

  // Eventos Pantalla 1
  pv117E1customLabel: 'TerminosyCondiciones',
  pv117E1setData: {
    pv117E1transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: 'TerminosYCondiciones',
    },
    pv117E1visitoragencystoreid: {
      path: 'visitor.agencystoreid',
      value: null,
    },
  },

  pv117E2customLabel: 'Cancelar',
  pv117E2setData: {
    pv117E2transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: 'TerminosYCondiciones',
    },
    pv117E2visitoragencystoreid: {
      path: 'visitor.agencystoreid',
      value: null,
    },
  },

  pv117E3customLabel: 'Continuar',
  pv117E3setData: {
    pv117E3transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: 'TerminosYCondiciones',
    },
    pv117E3visitoragencystoreid: {
      path: 'visitor.agencystoreid',
      value: null,
    },
  },

  pv117E4customLabel: 'Confirmacion',
  pv117E4setData: {
    pv117E4transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: 'TerminosYCondiciones',
    },
    pv117E4visitoragencystoreid: {
      path: 'visitor.agencystoreid',
      value: null,
    },
  },

  // Eventos de Pantallas ServiciosSolicitudConfigurar - Seguridad Clave

  // Eventos Pantalla 1
  pv118E1customLabel: 'CambiarClave',
  pv118E1setData: {
    pv118E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Seguridad',
    },
    pv118E1transactionName: {
      path: 'transaction.name',
      value: 'CambiarClave',
    },
    pv118E1transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: '1',
    },
  },
  pv118E1events: {
    name: 'transactionstep01',
    value: '1',
  },

  pv118E2customLabel: 'PreguntaSeguridad',
  pv118E2setData: {
    pv118E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Seguridad',
    },
    pv118E2transactionName: {
      path: 'transaction.name',
      value: 'CambiarClave',
    },
    pv118E2transactionDetailTransactionstep: {
      path: 'transaction.details.transactionstep',
      value: 'Checkout',
    },
  },
  pv118E2events: {
    name: 'transactioncheckout',
    value: '1',
  },

  // Eventos Pantalla 3
  pv120E1customLabel: 'ConfirmacionBloquearClave',
  pv120E1setData: {
    pv120E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Seguridad',
    },
    pv120E1transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: 'BloquearClave',
    },
  },

  // Eventos de  Pantallas TransferenciasBancosLocaisConsultar - Inscribir
  // Eventos Pantalla 1
  pv123E1customLabel: 'PreguntaDeSeguridad',
  pv123E1setData: {
    pv123E1transactionName: {
      path: 'transaction.name',
      value: 'InscribirCuentasTransferencias',
    },
  },

  // Eventos de Pantallas TransferenciasBancosLocaisConsultar - Home
  // Eventos Pantalla 4
  pv128E1customLabel: 'ErrorTransferenciasEjecutadas',
  pv128E1setData: {
    pv128E1transactionName: {
      path: 'transaction.name',
      value: 'TransferenciasProgramadas',
    },
  },

  // Eventos de AreaComunHomeConsultar - Home Productos
  // Eventos Pantalla 1
  pv129E1customLabel: 'SeleccionarProducto',
  pv129E1setData: {
    pv129E1transactionName: {
      path: 'transaction.name',
      value: 'ConsultaProductos',
    },
    pv129E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: null,
    },
  },

  // Eventos de InversionesDepositosPlazoFijoCambiar - Condiciones CDT
  // Eventos Pantalla 1
  pv130E1customLabel: 'ModificarInstrucciones',
  pv130E1setData: {
    pv130E1transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  pv130E2customLabel: 'RenovarCDT',
  pv130E2setData: {
    pv130E2transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  pv130E3customLabel: 'ConsultaCertificacionCDT',
  pv130E3setData: {
    pv130E3transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  // Eventos Pantalla 2
  pv131E1customLabel: 'CancelarModificarInstrucciones',
  pv131E1setData: {
    pv131E1transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  pv131E2customLabel: 'RegresarModificarInstrucciones',
  pv131E2setData: {
    pv131E2transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  // Eventos Pantalla 3
  pv132E1customLabel: 'CancelarResumenModificaciones',
  pv132E1setData: {
    pv132E1transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  pv132E2customLabel: 'RegresarResumenModificaciones',
  pv132E2setData: {
    pv132E2transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  // Eventos Pantalla 4
  pv133E1customLabel: 'GuardarComprobante',
  pv133E1setData: {
    pv133E1transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  pv133E2customLabel: 'ImprimirComprobante',
  pv133E2setData: {
    pv133E2transactionName: {
      path: 'transaction.name',
      value: 'CambiarCondicionesCDT',
    },
  },

  // Eventos Pantalla 1
  pv135E1customLabel: null,
  pv135E1setData: {
    pv135E1transactionName: {
      path: 'transaction.name',
      value: 'ConsultaProductos',
    },
    pv135E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: null,
    },
  },

};

export const COUNTRY = {
  ar: 'AR',
  cl: 'CL',
  co: 'CO',
  oca: 'OCA',
  py: 'PY',
  uy: 'UY',
};

export const BUSINNESS = {
  pf: 'PF',
  pj: 'PJ',
  un: 'UN',
};

export const ENVIRONMENT = {
  loggeado: 'LG',
  noLoggeado: 'NL',
};

export const CHANNEL = {
  apppn: 'APN',
  superapp: 'SA',
  apptarjetas: 'AT',
  homeBanking: 'HB',
  abreCuentas: 'AC',
  sitioPublico: 'SP',
};

export const FAMILY = {
  commonArea: 'AreaComun',
  care: 'Atendimento',
  campaigns: 'Campanas',
  accounts: 'Cuentas',
  fidelity: 'Fidelidad',
  investments: 'Inversiones',
  payment: 'Pagamentos',
  loan: 'Prestamo',
  insurance: 'Seguros',
  services: 'Servicios',
  cards: 'Tarjetas',
  transfers: 'Transferencias',
};

export const SUBFAMILY = {
  personalAccidents: 'AccidentesPersonales',
  aguinaldoAdvance: 'AdelantoAguinaldo',
  customs: 'Aduana',
  savingsForecast: 'AhorroPrevisionalUdutario',
  savingsScheduled: 'AhorroProgramado',
  feed: 'Alimentacion',
  proxies: 'Apoderados',
  automotive: 'Automotores',
  help: 'Ayuda',
  banksLocais: 'BancosLocais',
  basic: 'Basica',
  beneficiaries: 'Beneficiarios',
  profitCards: 'BeneficioTarjetas',
  boxSavings: 'CajaAhorro',
  juniorSavingsBox: 'CajaAhorroJunior',
  cashiers: 'Cajeros',
  change: 'Cambio',
  captureDocument: 'CapturaDocumento',
  certification: 'Certificacion',
  chat: 'Chat',
  checks: 'Cheques',
  checksFanfold: 'ChequesFanfold',
  tradeExterior: 'ComercioExterior',
  configurationLinking: 'ConfiguracionVinculacion',
  foreignCurrency: 'CorrienteMonedaExtranjera',
  LocalCurrencyStream: 'CorrienteMonedaLocal',
  credit: 'Credito',
  ownAccounts: 'CuentasPropias',
  virtualAccounts: 'CuentasVirtuales',
  debitoAutomatico: 'DebitoAutomatico',
  depositsTermFixed: 'DepositosPlazoFijo',
  digitization: 'Digitalizacion',
  outside: 'Dxterior',
  bill: 'Factura',
  faq: 'FAQ',
  finance: 'Finanzas',
  fonasa: 'Fonasa',
  funds: 'Fondos',
  form: 'Formulario',
  formInitial: 'FormularioInicial',
  turnsIEDE: 'GirosIEDE',
  datacontact: 'DatosContacto',
  mortgage: 'Hipotecarios',
  historicYTaxasCommissions: 'HistoricoComisionesYTaxas',
  HistoricOfUnderstandings: 'HistoricoDeComprovantes',
  home: 'Home',
  incomedata: 'IngresoDatos',
  irpf: 'IRPF',
  itau: 'Itau',
  landingPage: 'LandingPage',
  letterChange: 'LetraDeCambio',
  letterOfRegulation: 'LetrasDeRegulacionMonetaria',
  linkChannelYoutube: 'LinkCanalYoutube',
  limit: 'Limite',
  creditline: 'LineaDeCredito',
  login: 'Login',
  movements: 'Movimientos',
  notification: 'Notificacion',
  offerProducts: 'OfertaProductos',
  paymentsSMS: 'PagosSMS',
  shareholdingInCertificateOfDeposit: 'ParticipacionEnCertificadoDeDeposito',
  finalStep: 'PasoFinal',
  riskProfile: 'PerfilDeRiesgo',
  personal: 'Personales',
  pld: 'PLD',
  preapproved: 'Preaprobado',
  products: 'Productos',
  proposta: 'Proposta',
  promotions: 'Promociones',
  points: 'Puntos',
  recharge: 'Recarga',
  rechargeable: 'Recargable',
  fundraising: 'Recaudadoras',
  registration: 'Registro',
  health: 'Salud',
  security: 'Seguridad',
  self: 'Self',
  services: 'Servicios',
  overdraft: 'Sobregiro',
  request: 'Solicitud',
  surcursales: 'Surcursales',
  tariff: 'Tarifario',
  cards: 'Tarjetas',
  card: 'TarjetaDebito',
  tolls: 'Telepeaje',
  typechange: 'TipoCambio',
  titleWithSectiones: 'TituloConsecciones',
  travel: 'Viajes',
  life: 'Vida',
  view: 'Vista',
  wallet: 'Wallet',
};

export const PRODUCT = {
  open: 'Abrir',
  activate: 'Activar',
  add: 'Agregar',
  schedule: 'Agendar',
  block: 'Bloquear',
  change: 'Cambiar',
  cancel: 'Cancelar',
  redeem: 'Canjear',
  consult: 'Consultar',
  configure: 'Configurar',
  hire: 'Contratar',
  disable: 'Desabilitar',
  address: 'Direccionar',
  edit: 'Editar',
  remove: 'Eliminar',
  enable: 'Habilitar',
  log: 'Loguear',
  pay: 'Pagar',
  rescue: 'Rescatar',
  recharge: 'Recargar',
  request: 'Solicitar',
  offer: 'Ofertar',
  transfe: 'Transferir',
};
